import {isUndefined} from "util";
/**
 * Created by juan on 28/03/17.
 */

export interface Equable {
    equals(o: any) : boolean;
}

export class TSet<T extends Equable> {
    private elements: T[];

    constructor(a: T[] = []) {
        this.elements = a.filter(onlyUnique);
    }

    public fromArray(a: T[]) {
        this.elements = a.filter(onlyUnique);
    }

    public toArray(): T[] {
        return this.elements.slice();
    }

    public contains(element: T): boolean {
        return this.elements.some(e => e.equals(element));
    }

    public containsAll(a :T[]) {
        return a.every(t => this.contains(t));
    }

    public add(t: T) {
        if(!this.contains(t)) this.elements.push(t);
    }

    public remove(t: T) {
        let i = this.elements.findIndex(e => e.equals(t));
        if(!isUndefined(i)) this.elements.splice(i, 1);
    }

    public addAll(a: T[]) {
        a.forEach(t => this.add(t));
    }

    public removeAll(a: T[]) {
        a.forEach(t => this.remove(t));
    }
}

function onlyUnique(value, index, self) {
    return self.findIndex(v => v.equals(value)) == index;
}


// WEBPACK FOOTER //
// ./src/app/core/commons/utils/set.ts